/* Utils */
import { tvService } from '../../../../services/authService';
import { gaService } from '../../../../services/gaService';
import {
  REPORT_GA,
} from '../../../../utils/constants';

export default async function getToolboxRegistrationCode() {
  try {
    const response = await tvService.v2.tv.getDeviceCode();
    const { data } = response;
    gaService.sendEvent({
      action: REPORT_GA.GA_EVENT_ACTION_PIN_SUCCESS,
      label: ' ',
      category: REPORT_GA.GA_EVENT_CATEGORY_DEVICE_ACTIVATION,
    });
    const {
      user_code: userCode,
      expires_in: expiresIn,
      device_code: deviceCode,
    } = data;
    return {
      userCode,
      expiresIn,
      deviceCode,
    };
  } catch (error) {
    console.error('error', error);
    return {
      errorMessage: error?.message,
    };
  }
}
